import React, { useState, useEffect } from "react";
import {
   // Popconfirm,
   Empty,
   Button,
   // Menu,
   // Dropdown,
   message,
   Tabs,
   // Menu,
   // Dropdown,
   Row,
   Col
   // Progress
   // Popconfirm
   // Row,
   // Col
} from "antd";
import {
   // SearchOutlined,
   // EllipsisOutlined,
   // DeleteOutlined,
   PauseOutlined,
   LoadingOutlined,
   CaretRightOutlined,
   PlayCircleOutlined,
   PauseCircleOutlined
} from "@ant-design/icons";
import axios from "axios";
import useAxios from "axios-hooks";
import { Auth } from "aws-amplify";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PassportDetail } from "../Details/Drawer/PassportDetail";
import { AddDemand } from "../Details/Drawer/AddDemand";
import { Resource } from "../../../../api/common";
import { Matches } from "./Drawer/Matches";
// import { SourcingRequestDetails } from "./Drawer/SourcingRequestDetails";
// import { SellingRequestDetails } from "./Drawer/SellingRequestDetails";
import { RequestComments } from "./Drawer/RequestComments";
import { useAuth } from "../../../../contexts/auth/index";
import { SourcingRequestDetails } from "./Drawer/SourcingRequestDetails";
import OrderList from "./OrderList";
import ProgressBar from "../../../../components/ProgressBar";
import OrderListSeller from "./OrderListSeller";
// import Demands from "./Demands";

const { TabPane } = Tabs;

export const Materials = ({
   showDrawer,
   operation,
   refetch,
   dataSelectedMaterials,
   fetchMaterials,
   refetchSelectedMaterials,
   tabKey,
   callbackInnerTab,
   showDrawerLoading
}: any) => {
   const [selectedMaterials, setSelectedMaterials] = useState<any>([]);
   const { id: buildingId, operation_id }: any = useParams<string>();
   const [sellingStatus, setSellingStatus] = useState<number>(0);
   const [manageSellingLoading, setManageSellingLoading] =
      useState<boolean>(false);
   const [t] = useTranslation();
   const [showAddDemand, setShowAddDemand] = useState<boolean>(false);
   const [allDemandsList, setAllDemandsList] = useState<any>([]);
   const [showMatches, setShowMatches] = useState<boolean>(false);
   const [selectedMatch, setSelectedMatch] = useState<any>();
   const { user: currentUser } = useAuth();
   const isPrivateOwner =
      currentUser &&
      currentUser["attributes"] &&
      currentUser["attributes"]["custom:user_type"] === "private-owner";

   const [{ data: dataDemands, loading: getDemandsLoading }, getAllDemands] =
      useAxios(
         {
            url: `${Resource.path.demandApiUrl(buildingId, operation_id)}`,
            method: "GET"
         },
         { useCache: false }
      );

   useEffect(() => {
      if (dataSelectedMaterials?.data) {
         setSelectedMaterials(dataSelectedMaterials.data);
      }
      if (operation) {
         if (operation.selling_started !== undefined) {
            setSellingStatus(operation.selling_started);
         }
      }
      if (dataDemands?.data) {
         setAllDemandsList(dataDemands.data);
      }
   }, [dataSelectedMaterials, operation, dataDemands]);

   const addDemand = () => {
      setShowAddDemand(true);
   };

   const Passport = (props: any) => {
      const { selectedMat } = props;
      const [passportSpecification, setPassportSpecification] = useState<any>();
      const [showPassportDetail, setShowPassportDetail] =
         useState<boolean>(false);

      const { id, selling_started } = selectedMat;
      const [requestData, setRequestData] = useState<any>([]);
      const [orderData, setOrderData] = useState<any>([]);
      const [selectedRequest, setSelectedRequest] = useState<any>({});
      const [showRequestDetails, setShowRequestDetails] =
         useState<boolean>(false);
      console.log(showRequestDetails, "showRequestDetails");

      const [{ loading: deleteLoading }, removePassport] = useAxios(
         {
            url: `${Resource.path.operations}/${buildingId}/selling/${operation_id}/remove/${id}`,
            method: "DELETE"
         },
         { manual: true }
      );

      const [{ data: getRequestData }, fetchRequestDetails] = useAxios(
         {
            url: `${Resource.path.getSellingRequestData(
               buildingId,
               operation_id,
               id
            )}`,
            method: "GET"
         },
         { manual: false }
      );

      const [{ data: getOrdersData, loading: ordersLoading }, fetchOrders] =
         useAxios(
            {
               url: `${Resource.path.getSellingOrders(
                  buildingId,
                  operation_id,
                  id
               )}`,
               method: "GET"
            },

            { manual: true }
         );

      useEffect(() => {
         fetchOrders();
      }, []);

      useEffect(() => {
         getOrdersData?.data && setOrderData(getOrdersData?.data);
      }, [getOrdersData]);

      const showDetailPage = (material: any) => {
         setPassportSpecification(material);
         setShowPassportDetail(true);
      };

      const onCloseDetail = () => {
         setShowPassportDetail(false);
      };

      const confirmDelete = async () => {
         await removePassport()
            .then(() => {
               fetchMaterials();
               refetchSelectedMaterials();
            })
            .catch((error) => {
               console.log(error);
               message.error(t("buildingOperations.errorMessage"));
            });
      };

      const onCloseRequestDetails = () => {
         setSelectedRequest({});
         setShowRequestDetails(!showRequestDetails);
      };

      useEffect(() => {
         if (getRequestData?.data) {
            setRequestData(getRequestData.data);
         }
      }, [getRequestData]);

      const checkReserevdItems = () => {
         const items = orderData.filter(
            (item: { reserved: any }) => item.reserved
         );
         let totalAmount = 0;
         totalAmount += calcTotalPieces(items);
         return totalAmount;
      };

      const checkOrderedItems = () => {
         const items = orderData.filter(
            (item: { status: any }) => item.status == "ORDERED"
         );
         let totalAmount = 0;
         totalAmount += calcTotalPieces(items);
         return totalAmount;
      };

      const checkDeliveredItems = () => {
         const items = orderData.filter(
            (item: { status: any }) => item.status == "DELIVERED"
         );
         let totalAmount = 0;
         totalAmount += calcTotalPieces(items);
         return totalAmount;
      };

      // const MatchedData = (props: any) => {
      //    const { data, setSelectedRequest, getRequestDetails } = props;
      //    const [requestStatus, setRequestStatus] = useState(data.status);
      //    const [requestPaid] = useState(data.paid);
      //    const [showRequestComments, setShowRequestComments] = useState(false);

      //    const [{ loading: updateRequestLoading }, updateRequestStatus] =
      //       useAxios(
      //          {
      //             url: data.requests_building_id
      //                ? `${Resource.path.updateRequest(
      //                     data.requests_building_id,
      //                     data.requests_operations_id,
      //                     data.id,
      //                     data.requests_id
      //                  )}`
      //                : `${Resource.path.updateRequestHub(
      //                     data.id,
      //                     data.requests_id
      //                  )}`,
      //             method: "POST"
      //          },
      //          { manual: true }
      //       );

      //    const updateRequest = async (status: any) => {
      //       await updateRequestStatus({
      //          data: {
      //             status,
      //             comment: "",
      //             action_by: "SELLING"
      //          }
      //       })
      //          .then(() => {
      //             setRequestStatus(status);
      //          })
      //          .catch((error) => {
      //             console.log(error);
      //          });
      //    };

      //    if (updateRequestLoading) {
      //       (window as any).NProgress.start();
      //    } else {
      //       (window as any).NProgress.done();
      //    }

      //    return (
      //       <>
      //          <div className="request inner seller">
      //             <div className="matching-state">
      //                <figure className="demanded">
      //                   {data?.images && (
      //                      <img src={data?.images[0]?.object_url} />
      //                   )}
      //                   {!data?.images && (
      //                      <img src="data:image/png;base64,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" />
      //                   )}
      //                </figure>
      //             </div>
      //             <div className="item-name">
      //                <strong>{data.product_name}</strong>
      //                <span className="amount">
      //                   {data.requests_amount} {data.amount_unit}
      //                </span>
      //                {data?.selling_price && (
      //                   <span className="amount">
      //                      {data.selling_price} <b>€/{data.amount_unit}</b>
      //                   </span>
      //                )}
      //             </div>
      //             {requestStatus === "REQUESTED" && (
      //                <div className="status">
      //                   <small>Status</small>
      //                   <div className="current">
      //                      <span
      //                         className={`tag payment ${
      //                            requestPaid == 1 ? "paid" : "pending"
      //                         }`}
      //                      >
      //                         {data.proposal_price} €/{data.amount_unit}
      //                      </span>
      //                      <span className="tag">angefragt</span>
      //                   </div>
      //                   <div className="progress">
      //                      <div
      //                         className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                      ></div>
      //                   </div>
      //                </div>
      //             )}
      //             {requestStatus === "ACCEPTED" && !isPrivateOwner && (
      //                <div className="status">
      //                   <small>Status</small>
      //                   <div className="current">
      //                      <span
      //                         className={`tag payment ${
      //                            requestPaid == 1 ? "paid" : "pending"
      //                         }`}
      //                      >
      //                         {data.proposal_price} €/{data.amount_unit}
      //                      </span>
      //                      <span className="tag">angenommen</span>{" "}
      //                      {!isPrivateOwner && <span>Wird bearbeitet ...</span>}
      //                   </div>
      //                   <div className="progress">
      //                      <div
      //                         className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                      ></div>
      //                   </div>
      //                </div>
      //             )}
      //             {requestStatus !== "ACCEPTED" &&
      //                requestStatus !== "REQUESTED" &&
      //                !isPrivateOwner && (
      //                   <div className="status">
      //                      <small>Status</small>
      //                      <div className="current">
      //                         <span
      //                            className={`tag payment ${
      //                               requestPaid == 1 ? "paid" : "pending"
      //                            }`}
      //                         >
      //                            {data.proposal_price} €/{data.amount_unit}
      //                         </span>
      //                         <span className="tag">
      //                            {requestStatus.toLowerCase()}
      //                         </span>{" "}
      //                         {data?.hubspot_data?.properties
      //                            ?.seller_update && (
      //                            <span>
      //                               {
      //                                  data.hubspot_data.properties
      //                                     .seller_update.value
      //                               }
      //                            </span>
      //                         )}
      //                      </div>
      //                      <div className="progress">
      //                         <div
      //                            className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                         ></div>
      //                      </div>
      //                   </div>
      //                )}
      //             {requestStatus !== "ACCEPTED" &&
      //                requestStatus !== "REQUESTED" &&
      //                !!isPrivateOwner && (
      //                   <div className="status">
      //                      <small>Status</small>
      //                      <div className="current">
      //                         <span
      //                            className={`tag payment ${
      //                               requestPaid == 1 ? "paid" : "pending"
      //                            }`}
      //                         >
      //                            {data.proposal_price} €/{data.amount_unit}
      //                         </span>
      //                         <span className="tag">
      //                            {requestStatus.toLowerCase()}
      //                         </span>
      //                      </div>
      //                      <div className="progress">
      //                         <div
      //                            className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                         ></div>
      //                      </div>
      //                   </div>
      //                )}
      //             {requestStatus === "REQUESTED" && (
      //                <div className="actions">
      //                   <div className="order">
      //                      {!isPrivateOwner && (
      //                         <Button
      //                            type="primary"
      //                            onClick={() => {
      //                               updateRequest("ACCEPTED");
      //                            }}
      //                         >
      //                            Anfrage akzeptieren
      //                         </Button>
      //                      )}
      //                      {!!isPrivateOwner && (
      //                         <Button
      //                            type="primary"
      //                            onClick={() => {
      //                               updateRequest("IN-PROGRESS");
      //                            }}
      //                         >
      //                            Anfrage akzeptieren
      //                         </Button>
      //                      )}
      //                   </div>
      //                   <Button
      //                      type="default"
      //                      onClick={() => {
      //                         setSelectedRequest(data);
      //                      }}
      //                   >
      //                      Details
      //                   </Button>
      //                   {!!isPrivateOwner && (
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setShowRequestComments(true);
      //                         }}
      //                      >
      //                         Chat
      //                      </Button>
      //                   )}
      //                </div>
      //             )}
      //             {requestStatus !== "ACCEPTED" &&
      //                requestStatus !== "REQUESTED" &&
      //                !isPrivateOwner && (
      //                   <div className="actions">
      //                      {requestStatus !== "DELIVERED" &&
      //                         requestStatus !== "DECLINED" &&
      //                         requestStatus !== "FAILED" && (
      //                            <div className="order">
      //                               <Button
      //                                  type="primary"
      //                                  onClick={() => {
      //                                     updateRequest("DECLINED");
      //                                  }}
      //                               >
      //                                  Stornieren
      //                               </Button>
      //                            </div>
      //                         )}
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setSelectedRequest(data);
      //                         }}
      //                      >
      //                         Details
      //                      </Button>
      //                      {!!isPrivateOwner && (
      //                         <Button
      //                            type="default"
      //                            onClick={() => {
      //                               setShowRequestComments(true);
      //                            }}
      //                         >
      //                            Chat
      //                         </Button>
      //                      )}
      //                   </div>
      //                )}
      //             {requestStatus !== "ACCEPTED" &&
      //                requestStatus !== "REQUESTED" &&
      //                !!isPrivateOwner && (
      //                   <div className="actions">
      //                      {requestStatus !== "DECLINED" &&
      //                         requestStatus !== "FAILED" &&
      //                         requestStatus !== "DELIVERED" && (
      //                            <div className="order">
      //                               <Button
      //                                  type="primary"
      //                                  onClick={() => {
      //                                     updateRequest("DECLINED");
      //                                  }}
      //                               >
      //                                  Stornieren
      //                               </Button>
      //                               {requestStatus !== "DELIVERED" && (
      //                                  <Button
      //                                     type="primary"
      //                                     onClick={() => {
      //                                        updateRequest("DELIVERED");
      //                                     }}
      //                                  >
      //                                     Abschließen
      //                                  </Button>
      //                               )}
      //                            </div>
      //                         )}
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setSelectedRequest(data);
      //                         }}
      //                      >
      //                         Details
      //                      </Button>
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setShowRequestComments(true);
      //                         }}
      //                      >
      //                         Chat
      //                      </Button>
      //                   </div>
      //                )}
      //             {requestStatus === "ACCEPTED" && !isPrivateOwner && (
      //                <div className="actions">
      //                   <Button
      //                      type="default"
      //                      onClick={() => {
      //                         setSelectedRequest(data);
      //                      }}
      //                   >
      //                      Details
      //                   </Button>
      //                   {!!isPrivateOwner && (
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setShowRequestComments(true);
      //                         }}
      //                      >
      //                         Chat
      //                      </Button>
      //                   )}
      //                </div>
      //             )}
      //          </div>
      //          {!!isPrivateOwner && !!showRequestComments && (
      //             <RequestComments
      //                data={data}
      //                visible={showRequestComments}
      //                onClose={() => {
      //                   setShowRequestComments(!showRequestComments);
      //                }}
      //                created_by_type="SELLER"
      //             />
      //          )}
      //       </>
      //    );
      // };

      return (
         <>
            <div
               className={`matching-item-seller ${
                  selling_started !== 0 ? "searching" : "paused"
               }`}
               key={selectedMat.id}
            >
               <div className="matching-state-seller">
                  <Row className="sale inner">
                     <Col span={2} className="state">
                        <div className="search-icon">
                           <LoadingOutlined />
                           <CaretRightOutlined />
                        </div>
                        <div className="pause-icon">
                           <PauseOutlined />
                        </div>
                     </Col>
                     <Col
                        span={6}
                        className="item-info"
                        onClick={() => {
                           showDetailPage(selectedMat);
                        }}
                     >
                        <figure className="image">
                           {selectedMat?.images && (
                              <img src={selectedMat?.images[0]?.object_url} />
                           )}
                           {!selectedMat?.images && (
                              <img src="data:image/png;base64,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" />
                           )}
                        </figure>

                        <div className="title">
                           <strong>{selectedMat?.product_name}</strong>
                           <span className="amount">
                              {selectedMat?.amount_op}{" "}
                              {selectedMat?.amount_unit_op == "Stück"
                                 ? t("demands.pieces")
                                 : selectedMat?.amount_unit_op}{" "}
                           </span>
                        </div>
                     </Col>
                     <Col span={16} className="progress-state">
                        <div className="progress-bar">
                           <ProgressBar
                              bgcolor1={"#000000"}
                              bgcolor2={"#27b47c"}
                              bgcolor3={"#99e8ca"}
                              segment1={
                                 (checkReserevdItems() /
                                    selectedMat?.amount_op) *
                                 100
                              }
                              segment2={
                                 (checkOrderedItems() /
                                    selectedMat?.amount_op) *
                                 100
                              }
                              segment3={
                                 (checkDeliveredItems() /
                                    selectedMat?.amount_op) *
                                 100
                              }
                           />
                        </div>
                        <div className="progress-info">
                           {checkReserevdItems() ? (
                              <div className="reserved">
                                 {checkReserevdItems()}{" "}
                                 {selectedMat?.amount_unit_op == "Stück"
                                    ? t("demands.pieces")
                                    : selectedMat?.amount_unit_op}{" "}
                                 {"reserved"}
                              </div>
                           ) : null}
                           {checkOrderedItems() ? (
                              <div className="ordered">
                                 {checkOrderedItems()}{" "}
                                 {selectedMat?.amount_unit_op == "Stück"
                                    ? t("demands.pieces")
                                    : selectedMat?.amount_unit_op}{" "}
                                 {"ordered"}
                              </div>
                           ) : null}
                           {checkDeliveredItems() ? (
                              <div className="delivered">
                                 {checkDeliveredItems()}{" "}
                                 {selectedMat?.amount_unit_op == "Stück"
                                    ? t("demands.pieces")
                                    : selectedMat?.amount_unit_op}{" "}
                                 {"delivered"}
                              </div>
                           ) : null}
                        </div>
                        {/* <Button
                           shape="round"
                           className="more-details"
                           
                        >
                           {t("selling.details")}
                        </Button> */}
                     </Col>
                     {/* <div className="item-name">
                        <strong>{selectedMat.product_name}</strong>
                        <span className="amount">
                           {selectedMat.amount_op} {selectedMat.amount_unit_op}
                        </span>
                        {selectedMat?.max_selling_price &&
                           selectedMat?.min_selling_price &&
                           selectedMat?.max_selling_price !==
                              selectedMat?.min_selling_price && (
                              <span className="amount">
                                 {selectedMat.min_selling_price} -{" "}
                                 {selectedMat?.max_selling_price}{" "}
                                 <b>€/{selectedMat.amount_unit_op}</b>
                              </span>
                           )}
                        {selectedMat?.max_selling_price &&
                           selectedMat?.min_selling_price &&
                           selectedMat?.max_selling_price ===
                              selectedMat?.min_selling_price && (
                              <span className="amount">
                                 {selectedMat.min_selling_price}{" "}
                                 <b>€/{selectedMat.amount_unit_op}</b>
                              </span>
                           )}
                     </div> */}
                     {/* <div className="actions"> */}
                     {/* <Button
                           shape="round"
                           className="more-details"
                           onClick={() => {
                              showDetailPage(selectedMat);
                           }}
                        >
                           {t("selling.details")}
                        </Button> */}

                     {/* <Popconfirm
                           title={t("selling.deletePassport.title")}
                           onConfirm={confirmDelete}
                           okText={t("selling.deletePassport.okText")}
                           cancelText={t("selling.deletePassport.cancelText")}
                           okButtonProps={{ loading: deleteLoading }}
                           disabled={selling_started !== 0}
                        >
                           <Button type="link" disabled={selling_started !== 0}>
                              <DeleteOutlined />
                           </Button>
                        </Popconfirm> */}
                     {/* </div> */}
                  </Row>
               </div>
               {/* {isPrivateOwner &&
                  requestData.map((rec: any) => (
                     <MatchedData
                        data={rec}
                        getRequestDetails={fetchRequestDetails}
                        setSelectedRequest={(value: any) => {
                           setSelectedRequest(value);
                           setShowRequestDetails(!showRequestDetails);
                        }}
                     />
                  ))} */}
               {isPrivateOwner &&
                  orderData.map((rec: any) => (
                     <OrderListSeller data={rec} getData={fetchOrders} />
                  ))}
            </div>
            {showPassportDetail && (
               <PassportDetail
                  showRequestBtn={false}
                  visible={showPassportDetail}
                  onClose={onCloseDetail}
                  passportSpecification={passportSpecification}
               />
            )}
            {/* {selectedRequest && (
               <SellingRequestDetails
                  data={selectedRequest}
                  visible={showRequestDetails}
                  onClose={onCloseRequestDetails}
                  passportSpecification={passportSpecification}
               />
            )} */}
         </>
      );
   };

   const manageSelling = async (status: number) => {
      setManageSellingLoading(true);
      const accessToken = (await Auth.currentSession()).getIdToken();
      await axios
         .get(
            `${Resource.path.operations}/${buildingId}/selling/${operation_id}/status/${status}`,
            { headers: { Authorization: accessToken.getJwtToken() } }
         )
         .then(() => {
            setManageSellingLoading(false);
            refetch();
            fetchMaterials();
            refetchSelectedMaterials();
            setSellingStatus(status);
         })
         .catch((error) => {
            setManageSellingLoading(false);
            console.log(error);
            message.error(t("buildingOperations.errorMessage"));
         });
   };

   const onCloseDemand = () => {
      setShowAddDemand(false);
   };

   const Demands = (props: any) => {
      const { data, setShowMatches, showMatches, setSelectedMatch } = props;
      const { id, match_count, matches } = data;
      const [requestData, setRequestData] = useState<any>([]);
      const [selectedRequest, setSelectedRequest] = useState<any>({});
      const [showRequestDetails, setShowRequestDetails] =
         useState<boolean>(false);
      const [showRequestComments, setShowRequestComments] =
         useState<boolean>(false);
      const [allOrders, setAllOrders] = useState([]);
      const [{ data: ordersList }, getOrdersList] = useAxios(
         {
            url: `${Resource.path.ordersApiUrl(id)}`,
            method: "GET"
         },
         { manual: true }
      );

      useEffect(() => {
         getOrdersList();
      }, []);

      useEffect(() => {
         setAllOrders(ordersList?.data);
      }, [ordersList]);

      const [{ loading: deleteLoading }, removeDemand] = useAxios(
         {
            url: `${Resource.path.operations}/${buildingId}/demand/${operation_id}/remove/${id}`,
            method: "DELETE"
         },
         { manual: true }
      );

      const [{ loading: getLoading, data: getRequestData }, fetchRequestData] =
         useAxios(
            {
               url: `${Resource.path.getRequestUrl(
                  id,
                  buildingId,
                  operation_id
               )}`,
               method: "GET"
            },
            { manual: false }
         );

      const confirmDelete = async () => {
         await removeDemand()
            .then(() => {
               getAllDemands();
               message.success(t("demands.removeDemand.success"));
            })
            .catch((error) => {
               console.log(error);
               message.error(t("buildingOperations.errorMessage"));
            });
      };

      const getMatches = async () => {
         setSelectedMatch(data);
         setShowMatches(!showMatches);
      };

      const onCloseRequestDetails = () => {
         setSelectedRequest({});
         setShowRequestDetails(!showRequestDetails);
      };

      useEffect(() => {
         if (getRequestData?.data) {
            setRequestData(getRequestData.data);
         }
      }, [getRequestData]);

      // const MatchesData = (props: any) => {
      //    const { data, setSelectedRequest, getRequestData } = props;
      //    const [requestStatus, setRequestStatus] = useState(data.status);
      //    const [requestPaid] = useState(data.paid);
      //    const [showRequestComments, setShowRequestComments] =
      //       useState<boolean>(false);
      //    const [showOrderDetails, setShowOrderDetails] = useState(false);

      //    const [{ loading: updateRequestLoading }, updateRequestStatus] =
      //       useAxios(
      //          {
      //             url: `${Resource.path.updateRequest(
      //                data.building_id,
      //                data.operations_id,
      //                data.selling_id,
      //                data.id
      //             )}`,
      //             method: "POST"
      //          },
      //          { manual: true }
      //       );

      //    const [{ loading: deleteRequestLoading }, deleteRequest] = useAxios(
      //       {
      //          url: `${Resource.path.removeRequest(data.id)}`,
      //          method: "DELETE"
      //       },
      //       { manual: true }
      //    );

      //    const updateRequest = async (status: any) => {
      //       await updateRequestStatus({
      //          data: {
      //             status,
      //             comment: "",
      //             action_by: "SOURCING"
      //          }
      //       })
      //          .then(() => {
      //             setRequestStatus(status);
      //          })
      //          .catch((error) => {
      //             console.log(error);
      //          });
      //    };

      //    const reqestItemMenu = (
      //       <Menu>
      //          <Menu.Item
      //             key="1"
      //             disabled={!(requestStatus === "REQUESTED")}
      //             onClick={async (keys: any) => {
      //                await deleteRequest();
      //                await getRequestData();
      //             }}
      //          >
      //             {t("default.delete")}
      //          </Menu.Item>
      //          {!(requestStatus === "REQUESTED") && (
      //             <Menu.Item
      //                key="2"
      //                disabled={
      //                   requestStatus === "DECLINED" ||
      //                   requestStatus === "DELIVERED" ||
      //                   requestStatus === "FAILED" ||
      //                   requestStatus === "FAILED"
      //                }
      //                onClick={async (keys: any) => {
      //                   await updateRequest("DECLINED");
      //                   await getRequestData();
      //                }}
      //             >
      //                {"Cancel"}
      //             </Menu.Item>
      //          )}
      //       </Menu>
      //    );

      //    if (deleteRequestLoading) {
      //       (window as any).NProgress.start();
      //    } else {
      //       (window as any).NProgress.done();
      //    }

      //    return (
      //       <>
      //          <div className="request inner sourcing">
      //             <div className="matching-state">
      //                <figure className="demanded">
      //                   {data?.images && (
      //                      <img src={data?.images[0]?.object_url} />
      //                   )}
      //                   {!data?.images && (
      //                      <img src="data:image/png;base64,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" />
      //                   )}
      //                </figure>
      //             </div>
      //             <div className="item-name">
      //                <strong>{data.product_name}</strong>
      //                <span className="amount">
      //                   {data.amount} {data.amount_unit}
      //                </span>
      //                {data?.selling_price && (
      //                   <span className="amount">
      //                      {data.selling_price} <b>€/{data.amount_unit}</b>
      //                   </span>
      //                )}
      //                <Button
      //                   type="primary"
      //                   className="more-details"
      //                   onClick={() => {
      //                      setShowOrderDetails(true);
      //                   }}
      //                >
      //                   {t("demands.orderDetails")}
      //                </Button>
      //             </div>

      //             {requestStatus === "REQUESTED" && (
      //                <div className="status">
      //                   <small>Status</small>
      //                   <div className="current">
      //                      <span
      //                         className={`tag payment ${
      //                            requestPaid == 1 ? "paid" : "pending"
      //                         }`}
      //                      >
      //                         {data.proposal_price} €/{data.amount_unit}
      //                      </span>
      //                      <span className="tag">angefragt</span>{" "}
      //                      {!isPrivateOwner && (
      //                         <span>Auf Verkäufer warten ...</span>
      //                      )}
      //                   </div>
      //                   <div className="progress">
      //                      <div
      //                         className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                      ></div>
      //                   </div>
      //                </div>
      //             )}

      //             {requestStatus === "ACCEPTED" && !isPrivateOwner && (
      //                <div className="status">
      //                   <small>Status</small>
      //                   <div className="current">
      //                      <span
      //                         className={`tag payment ${
      //                            requestPaid == 1 ? "paid" : "pending"
      //                         }`}
      //                      >
      //                         {data.proposal_price} €/{data.amount_unit}
      //                      </span>
      //                      <span className="tag">angenommen</span>{" "}
      //                      {data?.hubspot_data?.properties?.buyer_update && (
      //                         <span>
      //                            {data.hubspot_data.properties.buyer_update}
      //                         </span>
      //                      )}
      //                   </div>
      //                   <div className="progress">
      //                      <div
      //                         className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                      ></div>
      //                   </div>
      //                </div>
      //             )}

      //             {requestStatus === "ACCEPTED" && !!isPrivateOwner && (
      //                <div className="status">
      //                   <small>Status</small>
      //                   <div className="current">
      //                      <span
      //                         className={`tag payment ${
      //                            requestPaid == 1 ? "paid" : "pending"
      //                         }`}
      //                      >
      //                         {data.proposal_price} €/{data.amount_unit}
      //                      </span>
      //                      <span className="tag">accepted</span>
      //                   </div>
      //                   <div className="progress">
      //                      <div
      //                         className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                      ></div>
      //                   </div>
      //                </div>
      //             )}
      //             {requestStatus !== "ACCEPTED" &&
      //                requestStatus !== "REQUESTED" &&
      //                !isPrivateOwner && (
      //                   <div className="status">
      //                      <small>Status</small>
      //                      <div className="current">
      //                         <span
      //                            className={`tag payment ${
      //                               requestPaid == 1 ? "paid" : "pending"
      //                            }`}
      //                         >
      //                            {data.proposal_price} €/{data.amount_unit}
      //                         </span>
      //                         <span className="tag">
      //                            {requestStatus.toLowerCase()}
      //                         </span>{" "}
      //                         {data?.hubspot_data?.properties?.buyer_update && (
      //                            <span>
      //                               {
      //                                  data.hubspot_data.properties.buyer_update
      //                                     .value
      //                               }
      //                            </span>
      //                         )}
      //                      </div>
      //                      <div className="progress">
      //                         <div
      //                            className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                         ></div>
      //                      </div>
      //                   </div>
      //                )}
      //             {requestStatus !== "ACCEPTED" &&
      //                requestStatus !== "REQUESTED" &&
      //                !!isPrivateOwner && (
      //                   <div className="status">
      //                      <small>Status</small>
      //                      <div className="current">
      //                         <span
      //                            className={`tag payment ${
      //                               requestPaid == 1 ? "paid" : "pending"
      //                            }`}
      //                         >
      //                            {data.proposal_price} €/{data.amount_unit}
      //                         </span>
      //                         <span className="tag">
      //                            {requestStatus.toLowerCase()}
      //                         </span>
      //                      </div>
      //                      <div className="progress">
      //                         <div
      //                            className={`progress-bar  ${requestStatus.toLowerCase()}`}
      //                         ></div>
      //                      </div>
      //                   </div>
      //                )}
      //             {requestStatus === "ACCEPTED" && !isPrivateOwner && (
      //                <div className="actions">
      //                   <div className="order">
      //                      <Button
      //                         type="primary"
      //                         onClick={() => {
      //                            updateRequest("IN-PROGRESS");
      //                         }}
      //                      >
      //                         Reservieren
      //                      </Button>
      //                   </div>
      //                   {/*<Button type="default" onClick={() => { setSelectedRequest(data) }}>Details</Button>*/}
      //                   {isPrivateOwner && (
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setShowRequestComments(true);
      //                         }}
      //                      >
      //                         Chat
      //                      </Button>
      //                   )}
      //                </div>
      //             )}
      //             {requestStatus !== "ACCEPTED" &&
      //                requestStatus !== "REQUESTED" && (
      //                   <div className="actions">
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setSelectedRequest(data);
      //                         }}
      //                      >
      //                         Details
      //                      </Button>
      //                      <Dropdown overlay={reqestItemMenu}>
      //                         <a
      //                            className="ant-dropdown-link dotted-menu"
      //                            onClick={(e) => e.preventDefault()}
      //                         >
      //                            <EllipsisOutlined />
      //                         </a>
      //                      </Dropdown>
      //                   </div>
      //                )}
      //             {requestStatus === "REQUESTED" && (
      //                <div className="actions">
      //                   {/*  <Button type="default" onClick={() => { setSelectedRequest(data) }}>Details</Button> */}
      //                   {isPrivateOwner && (
      //                      <Button
      //                         type="default"
      //                         onClick={() => {
      //                            setShowRequestComments(true);
      //                         }}
      //                      >
      //                         Chat
      //                      </Button>
      //                   )}

      //                   <Dropdown overlay={reqestItemMenu}>
      //                      <a
      //                         className="ant-dropdown-link dotted-menu"
      //                         onClick={(e) => e.preventDefault()}
      //                      >
      //                         <EllipsisOutlined />
      //                      </a>
      //                   </Dropdown>
      //                </div>
      //             )}
      //          </div>
      //          {!!isPrivateOwner && !!showRequestComments && (
      //             <RequestComments
      //                data={data}
      //                visible={showRequestComments}
      //                onClose={() => {
      //                   setShowRequestComments(!showRequestComments);
      //                }}
      //                created_by_type="BUYER"
      //             />
      //          )}

      //          {showOrderDetails && (
      //             <OrderDetailsModal
      //                visible={showOrderDetails}
      //                onCancel={() => setShowOrderDetails(false)}
      //                requestData={data}
      //             />
      //          )}
      //       </>
      //    );
      // };

      if (deleteLoading || getLoading) {
         (window as any).NProgress.start();
      } else {
         (window as any).NProgress.done();
      }

      const demandTags = () => {
         const items =
            allOrders &&
            allOrders.map((item: any) =>
               item?.requestData.map(
                  (request: { manufacturer: any }) => request.manufacturer
               )
            );
         const concatedList = items && [].concat.apply([], items);
         const uniqueList = concatedList
            ? concatedList.filter(
                 (element, index, array) => array.indexOf(element) === index
              )
            : [];
         return uniqueList.filter((item) => item);
      };

      return (
         <>
            <div
               className={`matching-item demand-item searching ${
                  match_count && match_count > 0 ? "has-matches" : ""
               }`}
            >
               <Row className="demand">
                  {/* <div className="matching-state">
                     <div className="search-icon">
                        <SearchOutlined />
                        <LoadingOutlined />
                     </div>
                  </div> */}
                  <Col span={4}>
                     <div className="name">
                        {data?.product_group
                           ? data.product_group
                           : data.product_group_id}
                     </div>
                  </Col>
                  <Col span={2}>
                     <span className="amount">
                        {isPrivateOwner
                           ? calcTotalPieces(requestData)
                           : calcTotalPieces(allOrders)}{" "}
                        {data?.unit == "Stück"
                           ? t("demands.pieces")
                           : data?.unit}
                     </span>
                     {/* <span className="amount">
                        {data.amount}{" "}
                        <b>
                           {data?.unit == "Stück"
                              ? t("demands.pieces")
                              : data?.unit}
                        </b>
                     </span> */}
                     {/* <span className="amount">
                        {data.target_price} <b>€/{data.unit}</b>
                     </span> */}
                  </Col>
                  <Col span={9} className={"d-flex"}>
                     {demandTags().map((item) => (
                        <div className="bordered-tag">{item}</div>
                     ))}{" "}
                  </Col>
                  {/* <Col span={12}>
                     <Popconfirm
                        title={t("demands.removeDemand.title")}
                        onConfirm={confirmDelete}
                        okText={t("demands.removeDemand.okText")}
                        cancelText={t("demands.removeDemand.cancelText")}
                        okButtonProps={{ loading: deleteLoading }}
                     >
                        <Button type="link">
                           <DeleteOutlined />
                        </Button>
                     </Popconfirm>
                  </Col> */}
                  <Col span={9} className="d-flex">
                     {!!match_count && match_count > 0 && (
                        <Button
                           type="primary"
                           className="shadow-button with-icon"
                           onClick={getMatches}
                        >
                           <span className="ico" />
                           {match_count} {t("default.matches")}
                        </Button>
                     )}
                     {allOrders &&
                        (allOrders.length ? (
                           <span className="shadow-tag">{`${allOrders.length} ${
                              allOrders && allOrders.length <= 1
                                 ? t("demands.order")
                                 : t("demands.orders")
                           }`}</span>
                        ) : null)}
                  </Col>
               </Row>
               {!isPrivateOwner
                  ? allOrders &&
                    allOrders.map((rec: any) => (
                       <>
                          <OrderList
                             data={rec}
                             id={id}
                             isPrivateOwner={isPrivateOwner}
                             getData={getOrdersList}
                          />
                          {!!isPrivateOwner && !!showRequestComments && (
                             <RequestComments
                                data={data}
                                visible={showRequestComments}
                                onClose={() => {
                                   setShowRequestComments(!showRequestComments);
                                }}
                                created_by_type="BUYER"
                             />
                          )}
                       </>
                    ))
                  : allOrders &&
                    allOrders.map((rec: any) => (
                       <>
                          <OrderList
                             data={rec}
                             id={id}
                             isPrivateOwner={isPrivateOwner}
                             getData={getOrdersList}
                          />
                          {!!isPrivateOwner && !!showRequestComments && (
                             <RequestComments
                                data={data}
                                visible={showRequestComments}
                                onClose={() => {
                                   setShowRequestComments(!showRequestComments);
                                }}
                                created_by_type="BUYER"
                             />
                          )}
                       </>
                    ))}
            </div>
            {showRequestDetails && (
               <SourcingRequestDetails
                  data={selectedRequest}
                  visible={showRequestDetails}
                  onClose={onCloseRequestDetails}
               />
            )}
         </>
      );
   };

   const onCloseMatches = () => {
      setShowMatches(false);
      setSelectedMatch(null);
   };

   if (getDemandsLoading) {
      (window as any).NProgress.start();
   } else {
      (window as any).NProgress.done();
   }

   const onTabChange = (key: any) => {
      getAllDemands();
      callbackInnerTab(key);
   };

   return (
      <Tabs defaultActiveKey={tabKey} onChange={onTabChange}>
         {operation.operation_type !== "construction" &&
            operation.operation_status !== "FINISHED" && (
               <TabPane tab={t("operations.tabs.selling")} key="1">
                  <div className="tab-pane-header">
                     <Button
                        type="primary"
                        loading={showDrawerLoading}
                        shape="round"
                        className="add"
                        onClick={showDrawer}
                     >
                        {t("selling.btn")}
                     </Button>
                  </div>
                  {selectedMaterials.length === 0 && (
                     <div className="matching-action start">
                        <div>
                           <h4>{t("selling.materialPilot.headingIntro")}</h4>
                           <p>{t("selling.materialPilot.messageIntro")}</p>
                        </div>
                        <div>
                           <Button
                              type="primary"
                              loading={showDrawerLoading}
                              shape="round"
                              className="add"
                              onClick={showDrawer}
                           >
                              {t("selling.btn")}
                           </Button>
                        </div>
                     </div>
                  )}
                  {sellingStatus === 0 && selectedMaterials.length > 0 && (
                     <div className="matching-action start">
                        <div>
                           <h4>{t("selling.materialPilot.heading")}</h4>
                           <p>{t("selling.materialPilot.message")}</p>
                        </div>
                        <div>
                           <Button
                              type="primary"
                              loading={manageSellingLoading}
                              shape="round"
                              icon={<PlayCircleOutlined />}
                              onClick={() => {
                                 manageSelling(1);
                              }}
                           >
                              {t("selling.materialPilot.startBtn")}
                           </Button>
                        </div>
                     </div>
                  )}
                  {sellingStatus !== 0 && (
                     <div className="matching-action running">
                        {/*<strong>number of views</strong>*/}
                        <Button
                           type="default"
                           loading={manageSellingLoading}
                           shape="round"
                           icon={<PauseCircleOutlined />}
                           onClick={() => {
                              manageSelling(0);
                           }}
                        >
                           {t("selling.materialPilot.stopBtn")}
                        </Button>
                     </div>
                  )}
                  <div className="matching-list seller">
                     {selectedMaterials.length > 0 &&
                        selectedMaterials.map((selectedMat: any) => (
                           <Passport selectedMat={selectedMat} />
                        ))}
                     {selectedMaterials.length === 0 && <Empty />}
                  </div>
               </TabPane>
            )}
         {operation.operation_type !== "deconstruction" &&
            operation.operation_status !== "FINISHED" && (
               <TabPane tab={t("operations.tabs.sourcing")} key="2">
                  <div className="tab-pane-header">
                     <Button
                        type="primary"
                        shape="round"
                        className="add"
                        onClick={() => {
                           addDemand();
                        }}
                     >
                        {t("demands.addDemand.btn")}
                     </Button>
                     {showAddDemand && (
                        <AddDemand
                           visible={showAddDemand}
                           onClose={onCloseDemand}
                           operation={operation}
                           getAllDemands={getAllDemands}
                        ></AddDemand>
                     )}
                  </div>
                  {allDemandsList.length === 0 && (
                     <div className="matching-action start">
                        <div>
                           <h4>{t("sourcing.materialPilot.heading")}</h4>
                           <p>{t("sourcing.materialPilot.message")}</p>
                        </div>
                        <Button
                           type="primary"
                           shape="round"
                           className="add"
                           onClick={() => {
                              addDemand();
                           }}
                        >
                           {t("demands.addDemand.btn")}
                        </Button>
                     </div>
                  )}
                  <div className="matching-list">
                     {allDemandsList.length > 0 &&
                        allDemandsList.map((demandsList: any) => (
                           <Demands
                              showMatches={showMatches}
                              setShowMatches={setShowMatches}
                              data={demandsList}
                              setSelectedMatch={setSelectedMatch}
                           />
                        ))}
                     {allDemandsList.length === 0 && <Empty />}
                  </div>
                  {selectedMatch && (
                     <Matches
                        visible={showMatches}
                        onClose={onCloseMatches}
                        selectedMatch={selectedMatch}
                     />
                  )}
               </TabPane>
            )}
         <TabPane tab={t("operations.tabs.statistics")} key="3">
            <Empty />
         </TabPane>
      </Tabs>
   );
};

const calcTotalPieces = (items: any[]) => {
   let total = 0;
   if (items)
      total = items
         .map((item: any) =>
            item.hasOwnProperty("requestData")
               ? item?.requestData.reduce(
                    (a: any, b: { [x: string]: any }) =>
                       a + (+b["amount"] || 0),
                    0
                 )
               : +item["amount"]
         )
         .reduce((a, b) => a + b, 0);
   return total;
};
